import React, { lazy } from "react";
import LazyLoading from "../common/components/LazyLoading/LazyLoading";
import { Route, Routes } from "react-router-dom";
import Component from "../pages/Services/ServicesContainer/components/Component";
import Navbar from "../common/components/Navbar/Navbar";

const Property = lazy(() =>
  import(
    "../pages/Services/ServicesContainer/components/SelectProperty/SelecteProperty"
  )
);

const PropertyDetails = lazy(() =>
  import(
    "../pages/Services/ServicesContainer/components/FillDetails/FillDetails"
  )
);

export const PropertyRouter = () => {
  // const Component = <div>Hi Hello</div>;
  const NewComponent = <div>
    <PropertyDetails />
  </div>
  return (
    <React.Suspense fallback={<LazyLoading />}>
          {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<Property />} />
        <Route path="filldetails" element={NewComponent} /> 
      </Routes>
    </React.Suspense>
  );
};
